/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Sign_InInputs */

const en_guest_book_sign_in = /** @type {(inputs: Guest_Book_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pl_guest_book_sign_in = /** @type {(inputs: Guest_Book_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Guest_Book_Sign_InInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_sign_in = /** @type {((inputs?: Guest_Book_Sign_InInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Sign_InInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_sign_in(inputs)
	return en_guest_book_sign_in(inputs)
});